<template>
    <div>
        <h3 class=" mb-3">{{ $t('student-details') }}</h3>

        <TextInput
            v-model="student.student_id_number"
            :label="$t('student-id-number')"
        />

        <TextInput
            v-model="student.hospital_resource_number"
            :label="$t('hospital-resource-no')"
        />

        <SelectInput
            v-model="student.programme_id"
            :options="$config.getValue('programmes')"
            :label="$t('programme')"
            optionLabel="Name"
            optionValue="Id"
        />

        <SelectInput
            v-model="student.year"
            :options="$config.getProgrammeYears(value.programme_id, true)"
            :label="$t('year')"
            :labelCb="year => $config.getYearStr(year, value.programme_id)"
        />

        <SelectInput
            v-model="student.group_id"
            :options="$config.getValue('groups')"
            :indexIsValue="true"
            :label="$t('group')"
        />

        <div v-if="group_changed && users.length !==0 && !this.action" class="card">
            <div class="card-header">
                {{ $t('timetable-change') }}
            </div>
            <div class="card-body">
                <p>{{ $t('timetable-change-text') }}</p>
                <div class="row">
                    <SelectSearch
                        v-model="user"
                        @input="error.user = false"
                        :options="users"
                        optionLabel="displayname"
                        :error="error.errors && error.user"
                        :nullLabel="$t('student')"
                        class="col-6"
                    />
                    <SelectSearch
                        v-model="timetable"
                        @input="error.timetable = false"
                        :options="timetables"
                        optionLabel="name"
                        :error="error.errors && error.user"
                        class="col-6"
                        :nullLabel="$t('timetable')"
                    />
                    <div class="col-12">
                        <button
                            class="btn btn-primary mt-3 float-right"
                            :disabled="!(user.id && timetable.id) "
                            @click="fetchEvents().then(() => { fetchBackgroundEvents() })"
                        >{{ $t('load-events') }}
                        </button>
                    </div>
                </div>
                
                
                <div class="row">
                    <IndividualTimetable
                        v-if="events.length"
                        :userId="Number(user.id)"
                        :from="from"
                        :until="until"
                        :events="events"
                        :bgEvents="bgEvents"
                        :listView="true"
                        :displayControls="false"
                        style="overflow:scroll; height:400px;"
                        class="mt-3"
                    />
                    <p class="ml-3" v-if="no_events">{{$t('could-not-find-events')}}</p>
                </div>
                <button
                    v-if="events.length"
                    class="btn btn-primary mt-3 float-right"
                    :disabled="!(user.id && timetable.id) "
                    @click="confirm"
                >{{ $t('copy-timetable') }}
                </button>
            </div>
        </div>
        <div v-if="action" class="col-12">
            <ActionModal 
                :title="error.error ? $t('error') : $t(action.title)"
                :text="error.error ? $t(error.message) : $t(action.message)"
                style="height: none;"
                :iconType="error.error ? 'exclamation-triangle-fill' : action.title === 'copying' ? '' : 'check-circle-fill'"
                :iconVariant="error.error ? 'danger' : 'success'"
            />
        </div>
        
        <SelectInput
            v-model="student.firm_id"
            :options="$config.getValue('firms')"
            :indexIsValue="true"
            :label="$t('firm')"
        />

        <SelectInput
            v-model="student.year_left"
            :options="lastTwentyYears"
            :label="$t('year-left')"
        />

        <SelectInput
            v-model="student.school_year_left"
            :options="$config.getProgrammeYears(value.programme_id, true)"
            :label="$t('school-year-left')"
            :labelCb="year => $config.getYearStr(year, value.programme_id)"
        />

        <CheckboxInput
            :label="$t('international-student')"
            :value="student.isinternational"
            @input="value => student.isinternational = value"
        />
    </div>
</template>

<script>
import SelectSearch from "src/components/Inputs/SelectSearch.vue";
import IndividualTimetable from "../../components/Timetables/IndividualTimetable.vue";
import ActionModal from 'src/components/ActionModal.vue'

export default {
    props: {
        value: {
            type: Object,
            default: () => { return {} }
        },
    },
    components: {
        SelectSearch,
        IndividualTimetable,
        ActionModal
    },
    mounted() {
        this.student = this.value
        if(this.student && this.student.group_id){
            this.initial_group_id = this.student.group_id
        }

        this.fetchTimetables();

    },
    data() {
        return {
            student: {},
            group_changed: false,
            initial_group_id: null,
            users: [],
            user: {},
            events: [],
			bgEvents: [],
            error: {
                error: false
            },
            from: null,
			until: null,
            timetables: [],
            timetable: {},
            no_events: false,
            action: null
        }
    },
    computed: {
        lastTwentyYears() {
            const years = []
            const thisYear = (new Date()).getFullYear()

            for (let i = thisYear; i >= thisYear - 20; i--) years.push(i)

            return years
        },
        todayDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
            }
        
    },
    methods:{
        getUsersByGroup() {
            this.user = {};
            this.timetable = {};
            return this.$cfetch(`${this.$settings.APIBaseURL}/users/list`, {
                method: 'POST',
                data: { group_id: this.student.group_id },
            }).then(res => {
                if (res.status === 'SUCCESS') {
                    this.users = res.results
                } 
            }).catch((err) => {
                console.error(err)
                this.$log.error.call(this, err)
            })
        },
        fetchTimetables(){
            return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/all`, {
				method: 'GET',
				data: {
					//status: 2,	
				}
			}).then(res => {
				if (res.status !== 'SUCCESS') throw new Error()

				this.timetables = res.results
			}).catch(err => {
				console.error(err)
				this.$log.error.call(this, err)
			})
        },
        fetchEvents() {
            this.events = [];
            this.no_events = false;
			return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/students/events/all`, {
				method: 'GET',
				data: {
					user_id: this.user.id,
					tttimetable_id: this.timetable.id,	// Can be undefined
				}
			}).then(res => {
				if (res.status !== 'SUCCESS') throw new Error()

                if(res.results.length == 0) this.no_events = true;
				this.events = res.results.map(event => {
					event.students = [{ id: this.student_id }]
					return event
				})
				this.from = this.todayDate
				this.until = res.to

			}).catch(err => {
				console.error(err)
				this.$log.error.call(this, err)
			})
		},
		fetchBackgroundEvents() {
			return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/students/backgroundevents/all`, {
				method: 'GET',
				data: {
					user_id: this.user.id,
					tttimetable_id: this.timetable.id, // Can be undefined
				}
			}).then(res => {
				if (res.status !== 'SUCCESS') throw new Error()

				this.bgEvents = res.results
			}).catch(err => {
				console.error(err)
				this.$log.error.call(this, err)
			})
		},
        confirm(){
            const self = this
            this.$store.commit("openDialog", {
				cancelBtn: true,
				title: this.$t("copy-timetable-question"),
				content: this.$t("this-will-copy-all-of-the-events-starting-from-today"),
				confirmCallBack: function () {
					self.copyTimetable();
				},
			});
        },
        copyTimetable(){
            this.action = {
                title: 'copying',
                message: 'copying-timetable'
            }

            return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/students/events/copy`, {
				method: 'POST',
				data: {
					origin_user_id: this.user.id,
                    target_user_id: this.$route.params.userId,
					tttimetable_id: this.timetable.id,
				}
			}).then(res => {
				if (res.status !== 'SUCCESS'){
                    this.error = {
                        error: true,
                        message: res.errorMessage,
                        type: res.errorType
                    }
                    throw new Error()
                }

				this.action = {
                    title: 'success',
                    message: 'done',
                    icon: 'check-circle-fill',
                    variant: 'success'
                }
			}).catch(err => {
				console.error(err)
				this.$log.error.call(this, err)
			})
        }
    },
    watch: {
        student: {
            handler (newValue) {
                const programme = this.$config.getProgrammeById(newValue.programme_id)

                if (parseInt(newValue.year) > parseInt(programme.CourseLengthYears) + 1) newValue.year = 1

                if(newValue && newValue.group_id !== this.initial_group_id){
                    this.group_changed = true 
                    this.getUsersByGroup();
                } 

                this.$emit('input', newValue)
            },
            deep: true,
        }
    },

}
</script>
